export default function hasPermission (permission, fallback) {
  return ({ next, store, nextVue }) => {
    const isAuthorized = store.getters['user/hasPermission'](permission);

    if (!isAuthorized) {
      return nextVue({ name: fallback });
    }

    return next();
  };
}
